/**
 * AdSense Configuration
 * 
 * Replace 'YOUR_AD_SLOT_ID_HERE' with your actual AdSense ad slot ID
 * You can find this in your Google AdSense dashboard under Ads > Overview
 * 
 * Format: Just the numeric ID (e.g., "1234567890"), not the full "ca-pub-..." string
 */
export const AD_SENSE_CONFIG = {
  // Banner ad slot ID for top banner on all pages
  TOP_BANNER_SLOT: '6223109058',
  
  // Banner ad slot ID for box scores popup
  BOX_SCORE_SLOT: '4157743567',
  
  // Publisher ID (already set in index.html)
  PUBLISHER_ID: 'ca-pub-4399752552614912',
};

